module.exports = __webpack_public_path__ + "static/media/5.8e1178d3.png";